import { Fragment } from 'react';
import './contatti.css';
import data from '../../utils/data.json';
import { useLanguage } from '../../context/LanguageContext';

const Contatti = () => {

    /* ------ Context API ------ */
    const { selectedLanguage, changeLanguage } = useLanguage();

    return (
        <div className='contatti-footer'>

            <div className='contatti_titolo'>
                <h1>{selectedLanguage === "ita" ? "CONTATTI" : "CONTACTS"}</h1>
                <p className="contatti_logo-footer" onClick={changeLanguage} >
                    {selectedLanguage === "ita" ? "🇬🇧" : "🇮🇹"}
                </p>
            </div>

            <div className='recapiti'>
                {data?.contatti?.map((recapito, index) => (
                    <Fragment key={recapito?.value}>
                        {(index === 0) ? (
                            <div className='recapito' key={recapito?.span}>
                                <span className={recapito?.class}>{recapito?.span}</span>                    
                                <p>{recapito?.value}</p>
                            </div>
                        ) : (
                            <div className='recapito' key={recapito?.span}>
                                <span className={recapito?.class}>{recapito?.span}</span>                    
                                <a
                                    href={recapito?.href}
                                    target="_blank"rel="noreferrer"
                                >
                                    {recapito?.value}
                                </a>
                            </div>
                        )}
                    </Fragment>
                ))}
            </div>
        </div>
    );
}

export default Contatti;